import styled from 'styled-components'

import { Flex } from 'Components/UI/_Legacy'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

export const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  width: 100%;
  z-index: 11;
`

export const Content = styled(Flex).attrs({
  px: LANDING_INLINE_PADDINGS,
})``
